import type { PaymentMethodsSettings } from '../types/paymentMethods/paymentMethodsSettings'

export const paymentMethodsFields = [
  'bank',
  'iban',
  'offlinePayment',
  'paypalEmail',
  'swift',
] as const satisfies readonly (keyof PaymentMethodsSettings)[]
